import { DataLayerEvent } from 'interfaces/window.model';

export const pushToDataLayer = (event: DataLayerEvent): void => {
  if (window.dataLayer && process.env.REACT_APP_ENABLE_ANALYTICS === 'true') {
    window.dataLayer.push(event);
  }
};
